export const FETCH_COUNSELLORS = "FETCH_COUNSELLORS"
export const UPDATE_COUNSELLOR = "UPDATE_COUNSELLOR"
export const FETCH_BAD_FIT = "FETCH_BAD_FIT"
export const DELETE_BAD_FIT_ITEM = "DELETE_BAD_FIT_ITEM"
export const UPDATE_BAD_FIT_ITEM = "UPDATE_BAD_FIT_ITEM"